export default __webpack_public_path__ + "static/media/middle_button.434fa1ac.png";